import React from "react";
import { FlexCol, FlexRow } from "./generic/Containers";
import { BCIcon, ICONS } from "./generic/BCIcons";
import { BCHeader3, Body2 } from "./generic/BCHeaders";
import "../css/GenericComponents.css";
import {
    CoursesMainMenu,
    VideosMainMenu,
    ResourceMainMenu,
    ToolsMainMenu,
    ReferencesMainMenu,
    ChallengesMainMenu,
    GamesMainMenu,
    BlogMainMenu
} from "./DashboardMainMenus";

interface ContentOverviewModalProps {
    isOpen: boolean;
    onClose: () => void;
    contentType: string;
}

export const ContentOverviewModal: React.FC<ContentOverviewModalProps> = ({
    isOpen,
    onClose,
    contentType
}) => {
    // Prevent background scrolling when modal is open
    React.useEffect(() => {
        if (isOpen) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }

        // Cleanup function to remove class when component unmounts
        return () => {
            document.body.classList.remove('modal-open');
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const getContentTitle = (type: string) => {
        switch (type) {
            case 'courses':
                return 'Courses';
            case 'videos':
                return 'Interviews from Real Devs';
            case 'resources':
                return 'Guides & Cheat Sheets';
            case 'tools':
                return 'AI Job Tools';
            case 'challenges':
                return 'Coding Challenges';
            case 'references':
                return 'References & APIs';
            case 'games':
                return 'Coding Games';
            case 'articles':
                return 'Articles & Blog Posts';
            default:
                return 'Content';
        }
    };

    const title = getContentTitle(contentType);

    const renderContent = () => {
        switch (contentType) {
            case 'courses':
                return <CoursesMainMenu setSelectedContent={() => {}} />;
            case 'videos':
                return <VideosMainMenu setSelectedContent={() => {}} />;
            case 'resources':
                return <ResourceMainMenu setSelectedContent={() => {}} />;
            case 'tools':
                return <ToolsMainMenu setSelectedContent={() => {}} />;
            case 'challenges':
                return <ChallengesMainMenu setSelectedContent={() => {}} />;
            case 'references':
                return <ReferencesMainMenu setSelectedContent={() => {}} />;
            case 'games':
                return <GamesMainMenu setSelectedContent={() => {}} />;
            case 'articles':
                return <BlogMainMenu setSelectedContent={() => {}} />;
            default:
                return <Body2 text="No content available for this type." />;
        }
    };

    return (
        <div className="overlay-container" onClick={onClose}>
            <FlexCol 
                className="overlay-content content-overview-modal" 
                onClick={(e) => e.stopPropagation()}
                maxWidth={80}
                widthPercent={90}
                gap={2}
                padding={2}
            >
                {/* Header */}
                <FlexRow justify="space-between" align="center" widthPercent={100}>
                    <BCHeader3 text={title} style={{fontSize: '1.5rem'}}/>
                    <BCIcon 
                        icon={ICONS.CLOSE} 
                        onClick={onClose}
                        className="content-overview-close-button"
                        style={{ cursor: 'pointer', fontSize: '1.5em' }}
                    />
                </FlexRow>

                {/* Content */}
                <FlexCol gap={2} widthPercent={100} padding={1} style={{ maxHeight: '70vh', overflowY: 'auto', border: '1px solid var(--color-primary-500)', borderRadius: '1em' }}>
                    {renderContent()}
                </FlexCol>
            </FlexCol>
        </div>
    );
};
